import axios from '@axios'

const group = 'report/'
const route = 'stock/stock_available'

export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {

    index(context, { itemsPerPage, page, filters }) {
      let pagination = `?page=${page}&items_per_page=${itemsPerPage}`
      return axios.post(`${group + route + pagination}`, filters)
    },

    exportExcel(context, { filters }) {
      return axios.post(`${group + route}/export_excel`, filters, { responseType: 'blob' })
    },

    exportPdf(context, { filters }) {
      return axios.post(`${group + route}/export_pdf`, filters, { responseType: 'blob' })
    },

  },

}
